import { get } from "../utils/FetchV2.util";
import type { MyCertificatesResponse } from "../../@types/FiscalDocuments.type";

/**
 * GET /certificates/me: certificados del usuario autenticado resueltos en servidor
 * (RFC + correo + teléfono), sin exigir RFC. Detrás de FEATURE_CERTIFICATES_ME en
 * el backend: si está apagado responde 404 y el caller debe tratarlo como vacío.
 */
export const fetchMyCertificatesService = async ({
  partnerId,
  page = 1,
  limit = 100,
}: {
  partnerId?: number;
  page?: number;
  limit?: number;
} = {}): Promise<MyCertificatesResponse> => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (partnerId) params.set("partnerId", String(partnerId));
  return await get({
    service: "bussiness",
    endpoint: `/certificates/me?${params.toString()}`,
  });
};

export const fetchRetentionCertificatesService = async ({
  userId,
  rfc,
  partnerId,
}: {
  userId: number;
  rfc?: string;
  tokenSession?: string;
  partnerId: number;
}) => {
  try {
    const response = await get({
      service: "bussiness",
      endpoint: `/certificates/user?partnerId=${partnerId}&user_id=${userId}&rfc=${rfc}`,
    });

    return response;
  } catch (error) {
    throw error;
  }
};
